import { render, staticRenderFns } from "./CompanyDesktopGroupOrdered.vue?vue&type=template&id=2d7bd75d"
import script from "./CompanyDesktopGroupOrdered.vue?vue&type=script&lang=js"
export * from "./CompanyDesktopGroupOrdered.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports